import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { Outlet } from "react-router-dom";
import { useState } from "react";
import Box from '@mui/material/Box';

export default function Layout({ setMode, mode }: { setMode: (mode: 'light' | 'dark') => void, mode: 'light' | 'dark' }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e3e8ee 100%)',
      fontFamily: 'Inter, Roboto, Arial, sans-serif',
    }}>
      <Sidebar 
        open={sidebarOpen} 
        setOpen={setSidebarOpen}
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
      />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Topbar 
          setSidebarOpen={setSidebarOpen} 
          sidebarOpen={sidebarOpen} 
          setMode={setMode} 
          mode={mode}
          sidebarCollapsed={sidebarCollapsed}
        />
        <Box component="main" sx={{ flex: 1, overflowY: 'auto', p: { xs: 1, sm: 2, md: 3, lg: 4 }, minHeight: 0 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
} 